import { render, staticRenderFns } from "./PanelApkUpgrade.vue?vue&type=template&id=248fe202&scoped=true"
import script from "./PanelApkUpgrade.vue?vue&type=script&lang=js"
export * from "./PanelApkUpgrade.vue?vue&type=script&lang=js"
import style0 from "./PanelApkUpgrade.vue?vue&type=style&index=0&id=248fe202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fe202",
  null
  
)

export default component.exports